import React from "react"
import SectionHeader from "./section-header"

const HowItWorks = ({ title = "How It Works", steps = [] }) => (
  <section className="howitworks mt-5">
    <div className="container px-5">
      <SectionHeader title={title} />
      <div className="columns is-variable is-2 is-align-items-stretch mt-5 mb-5">
        {steps.map(({ title, icon, descParts }, idx) => (
          <div
            className="column is-4-desktop is-4-tablet is-12-mobile pt-0"
            key={idx}
          >
            <div
              className="hiw-card background-blue-light py-6 px-6 is-flex is-flex-direction-column"
              style={{ borderRadius: 40, height: "100%" }}
            >
              <div>
                <h2 className="has-text-left howitworks-title has-text-weight-semibold is-size-3-desktop is-size-4-tablet is-size-3-mobile has-line-height-2 text-dark-blue">
                  {title}
                </h2>
              </div>

              <div className="is-flex is-justify-content-center is-align-items-center my-6-touch my-6-desktop">
                <img src={icon} />
              </div>

              <p className="has-text-left has-text-weight-light text-dark-blue">
                {descParts.map((part, i) => (
                  <span
                    key={i}
                    className={part.bold ? "has-text-weight-semibold" : ""}
                  >
                    {part.text}
                  </span>
                ))}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default HowItWorks
